// extracted by mini-css-extract-plugin
export default {"page":"order_page__biPXb","cart__list":"order_cart__list__GvzRv","title":"order_title__XWb1Y","aside":"order_aside__E7UCq"};